module.exports = __webpack_public_path__ + "img/20.61d74d03.jpg";